import * as s from "../RecordersStyled";
import {
  LicenseCount,
  SubscriptionInfo,
} from "api/interfaces/recorderInterface.interface";
import { StatusName, StatusValue } from "components/blocks/status/Status";
import SubscriptionStatus from "./SubscriptionStatus";
import { formatNumber } from "utils/functions";

type Props = {
  licenseCount: LicenseCount;
  subscriptionInfo?: SubscriptionInfo;
};

export default function LicenseInfo({
  licenseCount,
  subscriptionInfo,
}: Props): JSX.Element {
  return (
    <s.LicenseInfo>
      <s.LicenseInfoItem>
        <StatusName className="license-title">Cameras&nbsp;&nbsp;</StatusName>
        <StatusValue>{formatNumber(licenseCount.totalCameraCount)}</StatusValue>
      </s.LicenseInfoItem>
      {subscriptionInfo && (
        <SubscriptionStatus subscriptionInfo={subscriptionInfo} />
      )}
    </s.LicenseInfo>
  );
}
